import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/financials')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/financial' })
  },
})
